const ACCOUNT_SETUP_TOKEN_BYTE_LENGTH = 16;

export function isValidAccountSetupToken(token: string): boolean {
  const normalized = token.trim().replace(/-/g, "+").replace(/_/g, "/");
  const paddingLength = (4 - (normalized.length % 4)) % 4;
  const paddedToken = `${normalized}${"=".repeat(paddingLength)}`;

  try {
    return atob(paddedToken).length === ACCOUNT_SETUP_TOKEN_BYTE_LENGTH;
  } catch {
    return false;
  }
}
